import api from '@utils/api';

export const getTariffs = async (params) => {
  try {
    let url = '/finance/tariffs';
    const requestParams = { ...params };

    if (params && params.place_id) {
      url = `/finance/tariffs/place/${params.place_id}`;
      delete requestParams.place_id;
    }

    const response = await api.get(url, { params: requestParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching tariffs:', error);
    throw error;
  }
};

export const createTariff = async (tariffData) => {
  try {
    const response = await api.post('/finance/tariffs', tariffData);
    return response.data;
  } catch (error) {
    console.error('Error creating tariff:', error);
    throw error;
  }
};

export const updateTariff = async (id, tariffData) => {
  try {
    const response = await api.put(`/finance/tariffs/${id}`, tariffData);
    return response.data;
  } catch (error) {
    console.error(`Error updating tariff ${id}:`, error);
    throw error;
  }
};

export const deleteTariff = async (id) => {
  try {
    const response = await api.delete(`/finance/tariffs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting tariff ${id}:`, error);
    throw error;
  }
};

export const activateTariff = async (id) => {
  try {
    const response = await api.post(`/finance/tariffs/${id}/activate`);
    return response.data;
  } catch (error) {
    console.error(`Error activating tariff ${id}:`, error);
    throw error;
  }
};

export const getActiveTariff = async (place_id) => {
  try {
    const response = await api.get('/facturation/tariffs/active', { params: { place_id } });
    return response.data;
  } catch (error) {
    console.error('Error fetching active tariff:', error);
    throw error;
  }
};
